import React from 'react';
import ModifyEmailSchedulePage from './ModifyEmailSchedulePage';
import {
  getSchedule,
  postSchedule,
  unlockSchedule,
} from '../../../../api/schedule';
import { cloneDeep } from 'lodash';
import noti from '../../../../actions/toast';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

const ModifyEmailSchedule = (props) => {
  const { t } = useTranslation('app');
  const history = useHistory();
  const [unlockError, setUnlockError] = React.useState('');
  const [isActive, setIsActive] = React.useState(false);
  const [wait4GetSchedule, setWaiting4GetSchedule] = React.useState(false);
  const [form, updateForm] = React.useState({
    code: '',
    emailSubject: '',
    recipients: '',
    frequencyType: '0',
    time: new Date(),
    day: '1',
  });
  const [data, updateData] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  function onUnlock(code) {
    setUnlockError('');
    unlockSchedule(code)
      .then((unlockResult) => {
        if (unlockResult) {
          updateForm({ ...form, code });
          setIsActive(true);
        } else {
          setUnlockError('Invalid Code !!!');
        }
      })
      .catch((err) => console.log(err, 'unlock failed'));
  }
  React.useEffect(() => {
    if (isActive) {
      setWaiting4GetSchedule(true);
      getSchedule()
        .then((resp) => {
          if (resp) {
            const [hours, minutes, seconds] = resp.time.split(':');
            const time = new Date(
              new Date().setHours(+hours, minutes, seconds),
            );
            updateForm({
              code: form.code,
              emailSubject: resp.emailSubject,
              recipients: resp.recipients.join('\n'),
              frequencyType: resp.frequencyType.toString(),
              time,
              day: resp.day.toString(),
            });
            updateData(resp);
          }
        })
        .catch((err) => console.log(err, 'get schedule failed'))
        .finally(() => setWaiting4GetSchedule(false));
    }
  }, [isActive]);
  function onSubmit(values) {
    const _values = cloneDeep(values);
    const data = {
      ..._values,
      frequencyType: parseInt(_values.frequencyType),
      time: _values.time.toTimeString().split(' ')[0],
      day: parseInt(_values.day),
      recipients: _values.recipients.split('\n').map((re) => re),
    };
    setIsSubmitting(true);
    postSchedule(data)
      .then((resp) => {
        noti.success(t('Email Scheduled'));
        history.push('/system-admin-dashboard');
      })
      .catch((err) => console.log(err, 'post schedule failed'))
      .finally(() => setIsSubmitting(false));
  }
  return (
    <ModifyEmailSchedulePage
      form={form}
      onUnlock={onUnlock}
      isActive={isActive}
      unlockError={unlockError}
      wait4GetSchedule={wait4GetSchedule}
      isSubmitting={isSubmitting}
      onSubmit={onSubmit}
      data={data}
    />
  );
};

export default ModifyEmailSchedule;
